import React from 'react';

import { FieldTrip12025 } from '../views';

const AccountGeneralPage = () => {
  return <FieldTrip12025/>;
};

export default AccountGeneralPage;